import React, { Dispatch, SetStateAction, useState } from 'react';
import { ICustomerData, IServiceData } from 'src/environments/Checkout/interfaces';

import PurchasePaymentCreditCard from './Components/PurchasePaymentCreditCard';
import PurchasePaymentPix from './Components/PurchasePaymentPix';
import {
  BackArrowIcon,
  ButtonSelectPayment,
  ContainerChoosePayment,
  IconCreditCard,
  IconPix,
  TextSubTitle,
  TextTitle,
  TitleMethod,
} from './style';

import creditCardSVG from '../../../../../../assets/images/outfits-montage-icons/credit-card-black.svg';
import whiteArrowIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/white-arrow-left.svg';
import pixSVG from '../../../../../../assets/images/outfits-montage-icons/pix.svg';

type Props = {
  customerData: ICustomerData;
  serviceData: IServiceData;
  setComponent: Dispatch<SetStateAction<number>>;
  platform: string;
  couponId: number | null;
};

export default function ChoosePaymentMethod({
  customerData,
  serviceData,
  setComponent,
  platform,
  couponId,
}: Props): JSX.Element {
  const [showPaymentMethod, setShowPaymentMethod] = useState('');

  return (
    <ContainerChoosePayment>
      <BackArrowIcon
        src={whiteArrowIconSVG}
        onClick={() => {
          if (showPaymentMethod === '') {
            setComponent((prev: number) => prev - 1);
          } else {
            setShowPaymentMethod('');
          }
        }}
      />
      {showPaymentMethod === '' && (
        <>
          <TextTitle>Pagamento</TextTitle>
          <TextSubTitle>Escolha uma forma de pagamento</TextSubTitle>
          <ButtonSelectPayment
            bottomMargin="4vw"
            onClick={() => {
              setShowPaymentMethod('Cartão de crédito');
            }}
          >
            <IconCreditCard src={creditCardSVG} alt="Ícone de Cartão de crédito" />
            <TitleMethod>Cartão de Crédito</TitleMethod>
          </ButtonSelectPayment>
          <ButtonSelectPayment
            bottomMargin="30vw"
            onClick={() => {
              setShowPaymentMethod('Pix');
            }}
          >
            <IconPix src={pixSVG} alt="Ícone do pix" />
            <TitleMethod>PIX</TitleMethod>
          </ButtonSelectPayment>
        </>
      )}
      {showPaymentMethod === 'Cartão de crédito' && (
        <PurchasePaymentCreditCard
          customerData={customerData}
          serviceData={serviceData}
          platform={platform}
          setShowPaymentMethod={setShowPaymentMethod}
          couponId={couponId}
        />
      )}
      {showPaymentMethod === 'Pix' && (
        <PurchasePaymentPix
          customerData={customerData}
          serviceData={serviceData}
          platform={platform}
          setShowPaymentMethod={setShowPaymentMethod}
          couponId={couponId}
        />
      )}
    </ContainerChoosePayment>
  );
}
